import { render } from "./iloader.vue?vue&type=template&id=3f51f486&scoped=true"
import script from "./iloader.vue?vue&type=script&lang=js"
export * from "./iloader.vue?vue&type=script&lang=js"

import "./iloader.vue?vue&type=style&index=0&id=3f51f486&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f51f486"]])

export default __exports__